import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconRight(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={-163.34}
          x2={-199.88}
          y1={68.39}
          y2={31.85}
          gradientTransform="translate(221.49)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M39.88 86.66l-1.07-1.06 35.38-35.48-35.38-35.48 1.07-1.06 36.43 36.54-36.43 36.54z"
      />
    </svg>
  );
}
export default SvgEchIconRight;
